import { getDefaultFeatureFlags } from '../actions/getDefaultFeatureFlags';

const uberFlag = 'fwk-uberflag';
const consumerFlag = 'fwk-consumer';
const businessFlag = 'fwk-business';

export function checkUberFlight() {
    return getIntegrityFlights().includes(uberFlag) ? 1 : 0;
}

export function checkUserTypeFlight(isConsumer: boolean) {
    const integrityFlights = getIntegrityFlights();
    return (isConsumer &&
        integrityFlights.includes(consumerFlag) &&
        !integrityFlights.includes(businessFlag)) ||
        (!isConsumer &&
            integrityFlights.includes(businessFlag) &&
            !integrityFlights.includes(consumerFlag))
        ? 1
        : 0;
}

// Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
// -> Error TS7034 (26,5): Variable 'integrityFlags' implicitly has type 'any' in some locations where its type cannot be determined.
// @ts-expect-error
let integrityFlags;
function getIntegrityFlights() {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS7005 (31,10): Variable 'integrityFlags' implicitly has an 'any' type.
    // @ts-expect-error
    if (!integrityFlags) {
        integrityFlags = getDefaultFeatureFlags().filter(
            f => f === uberFlag || f === consumerFlag || f === businessFlag
        );
    }
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS7005 (39,12): Variable 'integrityFlags' implicitly has an 'any' type.
    // @ts-expect-error
    return integrityFlags;
}
